// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2T-XM","title":"Header_title__H1pjV","left":"Header_left__1fJxg","clinicName":"Header_clinicName__39dfL"};